import {
    Table,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledTableContainer = styled(Table.Responsive)`
    border: 1px solid ${token('colors.gray300')};
    border-radius: 2px;
    margin-bottom: ${spaceMixin(3)};
`;

export const StyledTableHeaderCell = styled(Table.HeaderCell)`
    && {
        ${mediaMixin('md', css`
            padding: ${spaceMixin('sm')} 0 ${spaceMixin('sm')} ${spaceMixin('sm')};
            min-width: 106px;

            &:last-child {
                padding-right: ${spaceMixin('sm')};
            }
        `)}

        ${mediaMixin('xl', css`
            padding: ${spaceMixin('sm')};
        `)}
    }
`;
